import { render, staticRenderFns } from "./LabelDisplay.vue?vue&type=template&id=7dc824b4&scoped=true"
import script from "./LabelDisplay.vue?vue&type=script&lang=js"
export * from "./LabelDisplay.vue?vue&type=script&lang=js"
import style0 from "./LabelDisplay.vue?vue&type=style&index=0&id=7dc824b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc824b4",
  null
  
)

export default component.exports